import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Rating from "react-rating"
import classNames from "classnames"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import CloseIcon from "@material-ui/icons/Close"
import StarIcon from "@material-ui/icons/Star"
import Tooltip from "@material-ui/core/Tooltip"

class RatingComponent extends Component {
  render() {
    const { classes } = this.props
    const readonly = this.props.userId === this.props.authenticatedUserId
    const communityRank = Math.round(this.props.avgRating * 10) / 10
    return (
      <div
        className={classNames(classes.rating, {
          [classes.readonly]: readonly,
        })}
      >
        <Tooltip
          title="My Ranking"
          placement={this.props.placement ? this.props.placement : "top"}
          enterTouchDelay={0}
        >
          <div>
            <Rating
              placeholderRating={
                this.props.selectedRating > 5 ? 5 : this.props.selectedRating
              }
              emptySymbol={
                // <i
                //   className={classNames(
                //     "icon-unstar",
                //     classes.ratingIcon,
                //     classes.unstarIcon
                //   )}
                // />
                <StarIcon
                  className={classNames(
                    "icon-star",
                    classes.ratingIcon,
                    classes.unstarIcon,
                  )}
                  classes={{ root: classes.icon }}
                  color="inherit"
                />
              }
              fullSymbol={
                // <i
                //   className={classNames(
                //     "icon-star",
                //     classes.ratingIcon,
                //     classes.starIcon,
                //     {
                //       [classes.selectedRating]:
                //         this.props.selectedRating !== null &&
                //         this.props.selectedRating !== undefined
                //     }
                //   )}
                // />
                <StarIcon
                  className={classNames(
                    "icon-star",
                    classes.ratingIcon,
                    classes.starIcon,
                    {
                      [classes.selectedRating]:
                        this.props.selectedRating !== null &&
                        this.props.selectedRating !== undefined,
                    },
                  )}
                  classes={{ root: classes.icon }}
                  color="inherit"
                />
              }
              placeholderSymbol={
                // <i
                //   className={classNames(
                //     "icon-star",
                //     classes.ratingIcon,
                //     classes.starIcon
                //   )}
                // />
                <StarIcon
                  className={classNames(
                    "icon-star",
                    classes.ratingIcon,
                    classes.starIcon,
                  )}
                  classes={{ root: classes.icon }}
                  color="inherit"
                />
              }
              onChange={this.props.ratingChanged}
              readonly={readonly}
            />
          </div>
        </Tooltip>
        <Tooltip
          title={`Community Rank (${Math.min(
            Math.max(parseInt(communityRank, 10), 0),
            5,
          )})`}
          placement={this.props.placement ? this.props.placement : "top"}
          enterTouchDelay={0}
        >
          <Typography variant="caption" className={classes.ratingCount}>
            {Math.min(Math.max(parseInt(communityRank, 10), 0), 5)} ({
              this.props.totalRatings
            })
          </Typography>
        </Tooltip>

        <div className={classes.superArea}>
          <Tooltip
            title="Do Not Use"
            placement={this.props.placement ? this.props.placement : "top"}
            enterTouchDelay={0}
          >
            <Button
              className={classNames(classes.superButton, classes.dislike)}
              onClick={() => this.props.ratingChanged(-1)}
            >
              <CloseIcon classes={{ root: classes.icon }} color="inherit" />
            </Button>
          </Tooltip>

          <Tooltip
            title="Preferred"
            placement={this.props.placement ? this.props.placement : "top"}
            enterTouchDelay={0}
          >
            <Button
              className={classNames(classes.superButton, classes.like)}
              onClick={() => this.props.ratingChanged(6)}
            >
              <StarIcon classes={{ root: classes.icon }} color="inherit" />
            </Button>
          </Tooltip>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authenticatedUserId: state.authentication.authenticatedUser.id,
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps),
)(RatingComponent)
